import {
  CLASS_HIDE,
  CLASS_DISABLES,
  CategoryAction,
  UpdateType,
  MIN_DESKTOP_MEDIA,
  FilterId
} from '../const';
import {
  showMessage,
  logMessage,
  start,
  end,
  getResponseByMode,
  makeElem
} from '../utils';
import {
  setSearchParams,
  pushHistoryState
} from './params';
import {
  Filter
} from './filter';
import {
  Toggler
} from './toggler';

export class Filters {
  constructor(container) {
    this._container = container;

    this._result = null;
    this._currentClass = null;
    this._updateView = null;
    this._controller = null;
    this._timer = 0;
    this._filters = null;
    this._selectFilters = null;
    this._enabledFilters = null;
    this._redirectFilter = null;
    this._redirectUrl = null;
    this._toggler = new Toggler();
    this._overlay = document.querySelector('.overlay');
    this._firstLoad = true;
    this._isDesktop = window.matchMedia(`(min-width: ${MIN_DESKTOP_MEDIA})`).matches;

    this._elemClickHandler = this._elemClickHandler.bind(this);
    this._elemChangeHandler = this._elemChangeHandler.bind(this);
    this._elemInputHandler = this._elemInputHandler.bind(this);
    this._overlayClickHandler = this._overlayClickHandler.bind(this);

    this._toggle = this._toggle.bind(this);

    this._init();
  }

  resetAllAndSubmit() {
    start();
    this._reset();
    this._elem.submit();
  }

  getFilter(id) {
    return this._filters.find((filter) => filter._id === id);
  }

  setFiltersHandler(callback) {
    this._updateView = callback;
  }

  update(status = UpdateType.LARGE) {

    return new Promise((resolve) => {
      clearTimeout(this._timer);

      this._timer = setTimeout(() => {

        if (this._controller) {
          this._controller.abort();
        }

        const whenFilterUpload = this._upload(status);
        resolve(whenFilterUpload);

      }, 0);
    });
  }

  _create() {
    const filters = this._elem.querySelectorAll('.block-filter');
    return Array.from(filters).reduce((array, item) => {
      let filter = {};
      filter = new Filter(item);
      this.update = this.update.bind(this);
      filter.setClickHandler(this.update);
      array.push(filter);
      return array;
    }, []);
  }

  _init() {
    this._elem = document.querySelector('.filters');
    if (this._elem === null) {
      return;
    }
    this._wrapper = this._elem.querySelector('.filters__wrapper');
    this._filters = this._create();

    this._checkEmpty();

    this._elem.addEventListener('click', this._elemClickHandler);
    this._elem.addEventListener('change', this._elemChangeHandler);
    this._elem.addEventListener('input', this._elemInputHandler);
    this._overlay.addEventListener('click', this._overlayClickHandler);

    this._checkRedirect();

    this.update(UpdateType.MEDIUM);
  }

  _checkEmpty() {
    if (this._filters.length > 0) {
      this._toggler.setClickHandler(this._toggle);
    } else {
      this._toggler.hide();
    }
  }

  _checkRedirect() {
    const path = window.location.pathname;
    // eslint-disable-next-line no-undef
    const array = redirectLinks;

    if (array) {
      const result = array.find(it => path.includes(it.href));

      if (result) {

        if (result.query) {
          console.log(result.query);
        }

        if (result.filter && result.param) {
          this._redirectFilter = this.getFilter(`filter-${result.filter}`);

          this._redirectUrl = this._redirectFilter.getUrlWithParam(result.filter, result.param);
          this._redirectFilter.checkInputByValue(result.param);
        }
      }
    }
  }

  _elemClickHandler(evt) {
    if (this._isFilter(evt)) {
      const filter = this._getFilter(evt.target);
      if (this._isDesktop) {
        this._filters.filter((elem) => elem.getId() !== filter.getId()).forEach((elem) => elem.hide());
      }
      filter.distributeClickHandler(evt.target);
    } else {
      this._distributeBtnHandler(evt.target);
    }
  }

  _elemChangeHandler(evt) {
    if (this._isCheckbox(evt.target)) {
      this.update();
    }
  }

  _elemInputHandler(evt) {
    if (this._isSearch(evt.target)) {
      const filter = this._getFilter(evt.target);
      filter.search();
    }
  }

  _overlayClickHandler() {
    this._toggle();

  }

  _distributeBtnHandler(elem) {
    if (this._isBtnShow(elem) || this._isBtnClose(elem)) {
      this._toggle();
    } else if (this._isBtnResetAll(elem)) {
      this.resetAllAndSubmit();
    }
  }

  _toggle() {
    this._wrapper.classList.toggle('active');
    this._overlay.classList.toggle('overlay--show');
    document.body.classList.toggle('overflow');
  }

  _reset() {
    this._filters.forEach(filter => filter.reset());
  }

  _resetInput(input) {
    input.checked = false;
    input.closest('.block-filter__item').classList.remove(CLASS_HIDE);
  }

  _clear() {
    this._clearOptions();
    this._clearClones();
  }

  _clearOptions() {
    this._currentId = '';

    this._selectFilters = new Set();
    this._enabledFilters = new Set();
  }

  _clearClones() {
    this._filters.forEach(filter => filter.clearStash());
  }

  _clearSearches() {
    this._filters.forEach(filter => filter.clearSearch());
  }

  _upload(status) {

    if (status === UpdateType.LARGE) {
      start();
    }
    if (status === UpdateType.MEDIUM || status === UpdateType.LARGE) {
      this._clearSearches();
    }

    const urlWithParams = this._getUrl();

    // конфигурируем запрос

    this._controller = new AbortController();
    const formData = new FormData(this._elem);
    formData.set('prepareUnijaxFilter', status);

    const mock = {
      url: 'mocks/filter.json',
      options: {
        method: 'GET',
        signal: this._controller.signal
      }
    };

    const real = {
      url: this._redirectUrl ? this._redirectUrl : urlWithParams.href,
      options: {
        method: 'POST',
        body: formData,
        signal: this._controller.signal
      }
    };

    const {
      url,
      options
    } = getResponseByMode(mock, real);

    return fetch(url, options).then((response) => {
      if (response.ok) {
        return response.json();
      }
      throw new Error(`Не получилось обновить фильтр`);
    })
      .then((data) => {
        this._currentClass = this._getHiddenClass(data['hide_non_active']);
        this._result = data['result'];

        switch (status) {
          case UpdateType.MEDIUM:
            this._updateFilters();
            this._container.classList.add('category__panel--loaded');
            break;
          case UpdateType.LARGE:
            this._updateFilters();
            this._updateView(CategoryAction.FILTERS, data.view);
            break;

          default:
            break;
        }


        this._controller = null;
        this._firstLoad = false;
        this._redirectUrl = null;
      })
      .catch((error) => {

        if (error.name !== 'AbortError') {
          logMessage(error);
          showMessage(error.message);
        }
      })
      .finally(() => {
        end();
      });
  }

  _getUrl() {
    const saveParams = this._firstLoad ? ['query', 'start', 'departments', FilterId.CLOTHES, FilterId.HATS, FilterId.SHOES] : ['query', 'departments', FilterId.CLOTHES, FilterId.HATS, FilterId.SHOES];
    return setSearchParams(saveParams);
  }

  _updateFilters() {
    this._clear();
    this._prepareControls();
    this._updateCountBadge();
    this._updateClasses();
    this._insertClones();
    this._updateSubs();
    this._hideRedirectFilter();
  }

  _hideRedirectFilter() {
    if (this._redirectFilter) {
      this._redirectFilter.getElem().classList.add('uf_hide');
    }
  }


  _updateCountBadge() {
    if (this._toggler !== null) {
      this._toggler.update(this._selectFilters.size);
    }
  }

  _prepareControls() {
    const checkboxs = Array.from(this._elem.querySelectorAll('input[type=checkbox]'));

    if (checkboxs.length > 0) {

      checkboxs.forEach((checkbox) => {
        this._currentId = checkbox.closest('.block-filter__wrapper').getAttribute('id');

        if (this._inResult(checkbox)) {
          this._showControl(checkbox);
        } else {
          this._hideControl(checkbox);
        }

        if (this._isHiddenControl(checkbox)) {
          this._collectClones(checkbox);
        }
      });
    }
  }

  _inResult(checkbox) {
    return this._result[checkbox.name].indexOf(checkbox.value) !== -1;
  }

  _showControl(checkbox) {
    if (checkbox.checked) {
      this._selectFilters.add(this._currentId);
    } else {
      checkbox.disabled = false;
      checkbox.parentNode.classList.remove(this._currentClass);

      this._enabledFilters.add(this._currentId);
    }
  }

  _hideControl(checkbox) {
    checkbox.disabled = true;
    this._resetInput(checkbox);
    checkbox.parentNode.classList.add(this._currentClass);
  }

  _updateClasses() {
    this._filters.forEach(filter => filter.update(this._selectFilters, this._enabledFilters, this._currentClass));

    if (this._isDesktop) {
      this._filters.forEach(filter => filter.hide());
    }

    this._updateCategoryTitles();
  }

  _updateCategoryTitles() {
    const category = this._filters.find(filter => filter.getId() === 'filter-category');
    if (category) {
      category.updateTitle();
    }
  }

  _collectClones(checkbox) {
    const wrapper = checkbox.closest('.block-filter__wrapper');
    const item = checkbox.closest('.block-filter__item');
    item.classList.add(CLASS_HIDE);
    this._stashClones(checkbox, wrapper.id);
  }


  _stashClones(checkbox, id) {
    const filter = this._filters.find(elem => elem.getWrapperId() === id);
    filter.stashClones(checkbox);
  }

  _insertClones() {
    this._filters.forEach(filter => filter.applyStash());
  }

  _updateSubs() {
    this._filters.forEach(filter => filter.updateSubs());
  }

  // Проверки

  _getFilter(elem) {
    const id = elem.closest('.block-filter').dataset.id;
    return this._filters.find(filter => filter._id === id);
  }

  _getHiddenClass(num) {
    return Number(num) === 0 ? CLASS_HIDE : CLASS_DISABLES;
  }

  _isTitle(elem) {
    return elem.closest('.block-filter__title');
  }

  _isLoadmore(elem) {
    return elem.closest('.block-filter__loadmore');
  }

  _isReset(elem) {
    return elem.closest('.block-filter__reset');
  }

  _isCheckbox(elem) {
    return elem.type === 'checkbox';
  }

  _isFilter(evt) {
    return (this._isReset(evt.target)) || (this._isTitle(evt.target)) || (this._isLoadmore(evt.target)) || (this._isCheckbox(evt.target) || (this._isCloneElem(evt.target)) || (this._isSubElem(evt.target)));
  }

  _isCloneElem(elem) {
    return elem.closest('.block-filter__clone');
  }

  _isSubElem(elem) {
    return elem.closest('.sub-filter__item');
  }

  _isSearch(elem) {
    return elem.classList.contains('control__input--search');
  }

  _isActiveBadge(elem) {
    return elem.classList.contains('filter-badge__button--active');
  }

  _isResetBadge(elem) {
    return elem.classList.contains('filter-badge__button--reset');
  }

  _isBtnShow(elem) {
    return elem.classList.contains('filters__btn--show');
  }

  _isBtnResetAll(elem) {
    return elem.classList.contains('filters__btn--reset');
  }

  _isBtnClose(elem) {
    return elem.classList.contains('filters__close');
  }

  _isChecked(input) {
    return input.checked;
  }

  _isNotEmptyValue(input) {
    return input.value > 0;
  }

  _isHiddenControl(input) {
    const list = input.closest('.block-filter__list');
    return input.type === 'checkbox' && input.checked && list.classList.contains('uf_hidecheckbox');
  }

  _isFiltersHtml(document) {
    const result = document.querySelector('.filters');
    return Boolean(result);
  }

  _setFilterParam() {
    const url = new URL(window.location.href);
    url.searchParams.set('moduleFilter', '1');
    return url.href;
  }
}
